import { render } from "./CategorieIndex.vue?vue&type=template&id=e3771226"
import script from "./CategorieIndex.vue?vue&type=script&lang=js"
export * from "./CategorieIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__